import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Facebook: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9_1041)">
        <path
          d="M16.4678 13.6875L17.001 10.2489H13.6669V8.01756C13.6669 7.07684 14.1326 6.15986 15.6259 6.15986H17.1416V3.2323C17.1416 3.2323 15.7661 3 14.451 3C11.7053 3 9.91052 4.64691 9.91052 7.62828V10.2489H6.8584V13.6875H9.91052V22H13.6669V13.6875H16.4678Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_1041">
          <rect
            width="12"
            height="19"
            fill="currentColor"
            transform="translate(6 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Facebook;
